var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('alert', {
    class: {
      'bg-white': _vm.card && !_vm.color
    },
    style: {
      minHeight: _vm.minHeightStyle
    },
    attrs: {
      "color": _vm.color,
      "icon": _vm.icon,
      "tile": _vm.tile,
      "xs-tile": _vm.xsTile,
      "sm-tile": _vm.smTile,
      "vertical": _vm.vertical,
      "spaced": "",
      "md-tile": _vm.mdTile,
      "lg-tile": _vm.lgTile,
      "shadow": _vm.shadow,
      "shadow-large": _vm.shadowLarge,
      "shadow-medium": _vm.shadowMedium,
      "shadow-small": _vm.shadowSmall || _vm.card,
      "no-spacing": _vm.noSpacing,
      "flat": _vm.flat,
      "content": _vm.text,
      "button": _vm.button,
      "to": _vm.to,
      "type": _vm.color,
      "button-icon": _vm.buttonIcon
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }